import { useSelector, useDispatch } from 'react-redux';
import FJImageToImageLeft from './FJImageToImageLeft';
import FJActionImageToImage from '../../../redux/action/FJActionImageToImage';
import { useCallback } from 'react';
import useLocalStore from '../../../hooks/useLocalStore';
import FJUtil from '../../../util/FJUtil';
import FJActionCommon from '../../../redux/action/FJActionCommon';
import { useMemo } from 'react';
import { STYLE_LIST } from '../../../config/dataConfig/FJImageToImageData';
import FJConstant from '../../../constants/FJConstant.js';

const FJImageToImageLeftContainer = () => {
    useLocalStore();

    const dispatch = useDispatch();
    const taskStatus = useSelector(state => state.imageToImage.taskStatus);
    const isProjectLoading = useSelector(state => state.common.isProjectLoading);
    const freeNumCreation = useSelector(state => state.imageToImage.freeNumCreation);
    const creditNumber = useSelector(state => state.common.creditNumber);
    const generateQuantity = useSelector(state => state.imageToImage.generateQuantity);
    const selectedStyle = useSelector(state => state.imageToImage.selectedStyle);

    const isPro = useMemo(() => {
        const category = STYLE_LIST.find(ca => ca.list.find(item => item.value === selectedStyle));
        const styleInfo = category ? category.list.find(item => item.value === selectedStyle) : {};
        return styleInfo.isPro;
    }, [selectedStyle]);
    const isExpensive = useMemo(() => {
        const category = STYLE_LIST.find(ca => ca.list.find(item => item.value === selectedStyle));
        const styleInfo = category ? category.list.find(item => item.value === selectedStyle) : {};
        return styleInfo.isExpensive;
    }, [selectedStyle]);

    const _onGenerate = useCallback(() => {
        if (FJUtil.isGeneratingStatus(taskStatus)) return;
        dispatch(FJActionImageToImage.generateAction());
        dispatch(FJActionCommon.setHeaderTabIndexAction(FJConstant.CREATIONS));
    }, [dispatch, taskStatus]);

    return (
        <FJImageToImageLeft
            generateQuantity={generateQuantity}
            onGenerate={_onGenerate}
            taskStatus={taskStatus}
            freeNumCreation={freeNumCreation}
            creditNumber={creditNumber}
            isProjectLoading={isProjectLoading}
            isPro={isPro}
            isExpensive={isExpensive}
        />
    );
};
export default FJImageToImageLeftContainer;
